/**
 * Finds a tags inside of a module that contain images and auto adds
 * builds a MicroModal instance containing an image built from the href,
 * attaches a listener to the wrapping a so that when the user clicks a
 * link it loads in a modal
 */
export default class Homepage {
    constructor(el) {
        this.el = el;
        this.vars();
        this.init();
    }
    vars() {
        this.orgs = this.el.querySelectorAll("[data-organization]");
        this.body = document.querySelector("body");
        this.orgWrapper = this.el.querySelector("#Org-Selector");
        this.activeCls = "s-active";
        this.inactiveCls = "s-inactive";
        this.activeIndex = null;
    }
    init() {
        // this.initOrgs();
        // this.getBgs();
        // this.watchOrgs();
    }

    getBgs() {
        this.bgs = this.el.querySelectorAll("[data-org-bg-effect]");
    }
    initOrgs() {
        this.orgs.forEach((e, i) => {
            const bg = e.dataset.bg;
            const bgContainer = document.createElement("div");
            e.dataset.index = i;
            bgContainer.classList.add("org-bg");
            bgContainer.classList.add("s-inactive");
            bgContainer.style.backgroundImage = `url(${bg})`;
            bgContainer.dataset.index = i;
            bgContainer.dataset.orgBgEffect = "";
            this.body.append(bgContainer);
        });
    }

    watchOrgs() {
        this.orgs.forEach((e) => {
            e.addEventListener("mouseenter", this.handleOrgOver);
            e.addEventListener("mouseleave", this.handleOrgOut);
        });
    }

    handleOrgOver = (e) => {
        const { currentTarget } = e;
        const index = currentTarget.dataset.index;
        const org = currentTarget.dataset.organization;
        this.handleSwapBg(index);
        this.handleSwapClass(org);
    };
    handleOrgOut = (e) => {
        this.removeClassFromOrgs();
        this.handleSwapClass();
    };

    // Swap background
    handleSwapBg(index) {
        if (index != this.activeIndex) {
            this.removeClassFromOrgs();
            this.orgWrapper.classList.add(this.activeCls);
            const updateBg = [...this.bgs].filter(
                (item) => item.dataset.index == index,
            );
            updateBg[0].classList.add(this.activeCls);
            updateBg[0].classList.remove(this.inactiveCls);
            this.activeIndex = index;
        }
    }

    handleSwapClass(org = "none") {
        if (org !== "none") {
            this.body.dataset.activeOrg = org;
            return;
        }
        this.body.dataset.activeOrg = "";
    }

    removeClassFromOrgs() {
        this.bgs.forEach((e) => {
            e.classList.remove(this.activeCls);
            e.classList.add(this.inactiveCls);
        });
        this.orgWrapper.classList.remove(this.activeCls);
    }
}
